import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import ListProvidersCmp from '../../shared/components/providers/list-providers-cmp';

const ListProvidersPage = () => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">Fournisseurs</h3>
      </Col>
      <Col md={12}>
        <ListProvidersCmp />
      </Col>
    </Row>
    <Row>
      
    </Row>
  </Container>
);

export default ListProvidersPage;